// @ts-ignore
import { VALIDATION_REGEXP } from '@r1-frontend/ui-react/components/input';

const checkFioIsValid = (fio: string): boolean => {
    return VALIDATION_REGEXP['cyrillicName'].test(fio);
};

export default checkFioIsValid;
